import { render } from "./Volonter.vue?vue&type=template&id=08835424"
import script from "./Volonter.vue?vue&type=script&lang=js"
export * from "./Volonter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__